{
  "language_toggle": {
    "label": "语言"
  },
  "common": {
    "studyfit": "StudyFit",
    "studyfitInc": "StudyFit Inc",
    "loading": "加载中...",
    "saving": "保存中...",
    "save": "保存",
    "cancel": "取消",
    "edit": "编辑",
    "delete": "删除",
    "remove": "移除",
    "back": "返回",
    "continue": "继续",
    "submit": "提交",
    "search": "搜索",
    "create": "创建",
    "view": "查看",
    "viewAll": "查看全部",
    "close": "关闭",
    "confirm": "确认",
    "copied": "已复制",
    "copy": "复制",
    "processing": "处理中...",
    "uploading": "上传中...",
    "download": "下载",
    "print": "打印",
    "or": "或",
    "of": "/",
    "more": "更多",
    "noResults": "未找到结果",
    "name": "姓名",
    "email": "邮箱",
    "role": "角色",
    "notSet": "未设置",
    "memberSince": "注册时间",
    "unit": "单元",
    "units": "单元",
    "lesson": "课时",
    "lessons": "课时",
    "student": "学生",
    "students": "学生",
    "activity": "活动",
    "activities": "活动",
    "question": "题目",
    "questions": "题目",
    "session": "课堂",
    "sessions": "课堂",
    "words": "词",
    "min": "分钟",
    "pages": "页",
    "completed": "已完成",
    "active": "进行中",
    "draft": "草稿",
    "archived": "已归档",
    "ready": "就绪",
    "scheduled": "已安排",
    "available": "可用",
    "locked": "未解锁",
    "inProgress": "进行中",
    "complete": "完成",
    "selectAll": "全选",
    "deselectAll": "取消全选",
    "clear": "清除",
    "networkError": "网络错误，请重试。",
    "chapter": "章",
    "chapters": "章",
    "collapsePanel": "收起面板",
    "failed": "失败",
    "begin": "开始",
    "viewResults": "查看结果"
  },
  "nav": {
    "dashboard": "仪表盘",
    "courses": "课程",
    "library": "资源库",
    "dictionary": "词典",
    "atlas": "地图集",
    "atlasMapSets": "地图集合",
    "calendar": "日历",
    "sentenceStudio": "造句工坊",
    "assessments": "测评",
    "users": "用户",
    "liveSession": "实时课堂",
    "essayComposer": "作文助手",
    "concepts": "概念",
    "tasks": "任务",
    "graphingCalculator": "图形计算器",
    "activityGenerator": "活动生成器",
    "vocabulary": "词汇",
    "expandSidebar": "展开侧栏",
    "collapseSidebar": "收起侧栏",
    "collapse": "收起",
    "logIn": "登录",
    "logOut": "退出",
    "profile": "个人资料",
    "teacher": "教师",
    "stopImpersonating": "停止模拟",
    "impersonating": "正在模拟 {{name}}（{{role}}）。当前登录为 {{trueName}}。"
  },
  "auth": {
    "signIn": "登录",
    "signingIn": "登录中...",
    "register": "注册",
    "createTeacherAccount": "创建教师账号",
    "firstName": "名",
    "firstNamePlaceholder": "小明",
    "lastName": "姓",
    "lastNamePlaceholder": "张",
    "preferredName": "昵称",
    "preferredNamePlaceholder": "我们该怎么称呼您？",
    "email": "邮箱",
    "emailPlaceholder": "you@school.edu",
    "password": "密码",
    "passwordHint": "至少8个字符",
    "confirmPassword": "确认密码",
    "confirmPasswordPlaceholder": "再次输入密码",
    "creatingAccount": "创建账号中...",
    "createAccount": "创建账号",
    "alreadyHaveAccount": "已有账号？",
    "areYouStudent": "你是学生吗？",
    "joinWithCode": "使用代码加入",
    "studentJoinWithCode": "学生？使用代码加入",
    "signInHere": "在此登录"
  },
  "join": {
    "joinLesson": "加入课堂",
    "joinCode": "加入代码",
    "joinCodePlaceholder": "ABC123",
    "joinCodeHelp": "输入教师提供的6位代码",
    "yourName": "你的姓名（可选）",
    "namePlaceholder": "你希望怎么称呼？",
    "joining": "加入中...",
    "joinSession": "加入课堂",
    "areYouTeacher": "你是教师吗？",
    "pleaseEnterCode": "请输入加入代码",
    "invalidCode": "无效的加入代码，请检查后重试。",
    "sessionClosed": "此课堂已停止接受参与者。"
  },
  "profile": {
    "title": "个人资料",
    "subtitle": "您的账户信息",
    "emailPlaceholder": "you@example.com",
    "gradeLevel": "年级",
    "avatarColor": "头像颜色",
    "avatarColorHint": "为您的姓名首字母头像选择一种颜色。",
    "calendarSubscription": "日历订阅",
    "calendarSyncDescription": "将课程安排同步到 Apple 日历、Google 日历或 Outlook。",
    "feedUrl": "订阅链接",
    "regenerateLink": "重新生成链接",
    "privateTokenWarning": "此链接包含私密令牌，请勿公开分享。",
    "generateCalendarLink": "生成日历链接",
    "calendarLinkGenerated": "日历链接已生成",
    "calendarLinkRegenerated": "日历链接已重新生成。旧链接将失效。",
    "learningProgress": "学习进度",
    "activitiesCompleted": "已完成活动",
    "wordsMastered": "已掌握单词",
    "streakDays": "天连续学习",
    "sentencesAnalyzed": "已分析句子",
    "wordsInReview": "复习中单词",
    "wordsOnboarding": "学习中单词",
    "enrolledCourses": "已报名课程",
    "recentSessions": "最近练习",
    "noRecentSessions": "暂无已完成的练习。",
    "noEnrolledCourses": "尚未报名任何课程。"
  },
  "studentDashboard": {
    "welcomeBack": "欢迎回来，",
    "continueWhereLeftOff": "从上次中断处继续",
    "yourCourses": "我的课程",
    "noCourses": "暂无课程",
    "noCoursesHelp": "向教师索取课程注册码即可开始学习。",
    "continueLearning": "继续学习",
    "review": "复习",
    "yourSkills": "我的技能",
    "skillsHelp": "完成练习后即可开始追踪你的技能",
    "moreSkills": "更多技能",
    "vocabulary": "词汇",
    "vocabComingSoon": "词汇追踪功能即将上线",
    "vocabReviewDue_one": "{{count}} 个词语待复习",
    "vocabReviewDue_other": "{{count}} 个词语待复习",
    "vocabOnboardingPending_one": "{{count}} 个新词语待学习",
    "vocabOnboardingPending_other": "{{count}} 个新词语待学习",
    "studyVocabulary": "学习词汇",
    "lessonsComplete": "已完成 {{completed}} / {{total}}"
  },
  "studentActivities": {
    "yourActivities": "我的活动",
    "subtitle": "追踪你的活动完成进度",
    "noActivities": "暂无可用活动",
    "noActivitiesHelp": "请稍后再来查看新的练习活动。"
  },
  "studentCourse": {
    "upNext": "下一步",
    "noLessonsYet": "此单元暂无课时。",
    "noUnitsYet": "此课程暂无单元。",
    "comingSoon": "即将推出",
    "unitProgress_one": "已完成 {{count}} 节课中的 {{completed}} 节",
    "unitProgress_other": "已完成 {{count}} 节课中的 {{completed}} 节"
  },
  "studentVocab": {
    "myVocabulary": "我的词汇",
    "youHave": "你有",
    "word": "个词",
    "dueForReview": "需要复习",
    "practiceTitle": "熟能生巧",
    "studyNow": "立即学习",
    "myWords": "我的词汇",
    "assigned": "已布置",
    "noWordsYet": "暂无词汇。在阅读中选择文本即可添加词汇。",
    "noAssignedWords": "暂无已布置的词汇。"
  },
  "practice": {
    "step1of3": "第1步，共3步",
    "step2of3": "第2步，共3步",
    "step3of3": "第3步，共3步",
    "step3Feedback": "第3步，共3步 — 反馈",
    "reading": "阅读",
    "questions": "问题",
    "reviewLabel": "复习",
    "saveAndExit": "保存并退出",
    "backToDashboard": "返回仪表盘",
    "backToReading": "返回阅读",
    "backToResults": "返回结果",
    "analyzingResponses": "正在分析你的回答...",
    "readingResponses": "正在阅读你的回答...",
    "practiceComplete": "练习完成！",
    "greatEffort": "做得好！以下是你的个性化反馈。",
    "heresFeedback": "以下是你的个性化反馈。",
    "skillsOverview": "技能概览",
    "demonstrated": "已展示",
    "continueToPractice": "继续练习",
    "correct": "正确",
    "incorrect": "错误",
    "pendingReview": "待批改",
    "answered": "已作答",
    "typeAnswerHere": "在此输入你的答案...",
    "writeResponseHere": "在此写下你的回答...",
    "writeEssayHere": "在此撰写你的文章...",
    "preferHandwriting": "更喜欢手写？",
    "uploadHandwritten": "上传手写回答的照片",
    "submittingResponses": "提交回答中...",
    "takeYourTime": "请认真阅读",
    "considerPrinting": "建议打印出来或找一个安静的地方。深度阅读带来深度理解。",
    "finishedReading": "我已读完",
    "readInPeace": "安静地去阅读吧。",
    "comeBackWhenDone": "读完后回到这里。",
    "doneReading": "我读完了",
    "takeTimeReading": "请认真阅读",
    "step": "步骤",
    "exercise": "练习",
    "readPassage": "阅读以下段落：",
    "exerciseIntro": "根据你的回答，让我们来巩固这项技能。",
    "checking": "检查中...",
    "checkAnswer": "检查答案",
    "finish": "完成",
    "nextExercise": "下一题"
  },
  "practiceChoose": {
    "title": "你的阅读作业",
    "subtitle": "选择你今天的阅读方式",
    "researchShows": "研究表明",
    "how": "如何",
    "you": "阅读",
    "what": "决定了",
    "youRemember": "你记住了什么。",
    "noWrongChoice": "没有错误的选择——最佳媒介取决于你的阅读目标。",
    "printTitle": "打印后离线阅读",
    "printDescription": "下载 PDF 打印或在专用设备上远离干扰地阅读。",
    "deeperProcessing": "更深层的认知加工",
    "deeperProcessingDesc": "固定的文字位置帮助大脑建立信息的\"心理地图\"，提高对细节的记忆。",
    "betterCalibration": "更准确的自我评估",
    "betterCalibrationDesc": "纸质阅读者更能准确预测自己的理解程度——你会知道自己真正学到了什么。",
    "fewerDistractions": "更少干扰",
    "fewerDistractionsDesc": "纸质阅读的\"静止感\"减少了多任务处理或查看通知的冲动。",
    "bestFor": "最适合：",
    "deepStudy": "深入学习复杂信息",
    "longTexts": "长篇或技术类文本",
    "rememberDetails": "需要记忆细节时",
    "downloadPdf": "下载 PDF",
    "minRead": "分钟阅读",
    "screenTitle": "在屏幕上阅读",
    "screenDescription": "在应用内直接阅读，使用互动功能并即时访问题目。",
    "fasterNavigation": "更快的导航",
    "fasterNavigationDesc": "快速扫描以找到要点、搜索关键词并在章节间跳转。",
    "interactiveFeatures": "互动功能",
    "interactiveFeaturesDesc": "无缝过渡到题目，即时反馈和集成评估。",
    "agileLearning": "灵活学习",
    "agileLearningDesc": "最适合快速理解任务，需要了解大意而非记忆细节。",
    "quickScanning": "快速扫描要点",
    "interactiveLearning": "带反馈的互动学习",
    "shorterTexts": "较短或熟悉的文本",
    "beginReading": "开始阅读"
  },
  "teacherDashboard": {
    "welcome": "欢迎，",
    "teacher": "教师",
    "subtitle": "管理你的活动并追踪学生进度",
    "readyToTeach": "准备好上课了吗？",
    "readyToTeachDesc": "创建一个活动，几分钟内即可开始授课。",
    "startNow": "立即开始",
    "totalActivities": "活动总数",
    "activeSessions": "进行中的课堂",
    "totalStudents": "学生总数",
    "studentsWorkingNow": "学生正在完成这些活动",
    "yourCourses": "我的课程",
    "standaloneLessons": "独立课时",
    "standaloneLessonsDesc": "未附属于任何课程的课时",
    "yourActivities": "我的活动",
    "newActivity": "新建活动",
    "noActivities": "暂无活动",
    "noActivitiesHelp": "创建你的第一个活动。添加阅读材料、视频或任何素材，让 AI 帮你起草题目。",
    "createFirstActivity": "创建第一个活动",
    "studentsJoined": "学生已加入",
    "joinCode": "加入代码"
  },
  "teacherActivities": {
    "title": "活动",
    "subtitle": "创建和管理你的活动内容",
    "newActivity": "新建活动",
    "noActivities": "暂无活动",
    "noActivitiesHelp": "创建你的第一个活动。添加阅读材料、视频或任何素材，让 AI 帮你起草题目。",
    "createFirstActivity": "创建第一个活动",
    "drafts": "草稿",
    "draftsDesc": "进行中的活动",
    "ready": "就绪",
    "readyDesc": "可用于课堂",
    "active": "进行中",
    "activeDesc": "正在使用中",
    "questionsApproved": "题目已审批"
  },
  "teacherActivityNew": {
    "title": "新建活动",
    "untitled": "未命名活动",
    "stimulusHeading": "教学材料（素材）",
    "stimulusDescription": "学生将阅读和回答的内容。",
    "contentType": "内容类型",
    "bookChapter": "书籍章节",
    "pdfDocument": "PDF 文档",
    "urlLink": "网址/链接",
    "video": "视频",
    "articleText": "文章/文本",
    "articlePlaceholder": "在此粘贴或输入文章文本...",
    "videoPlaceholder": "粘贴 YouTube、Vimeo 或其他视频链接",
    "urlPlaceholder": "粘贴文章或网页链接",
    "imagePlaceholder": "粘贴图片链接",
    "pdfDropzone": "将 PDF 拖放到此处或点击上传",
    "pdfLimit": "PDF 文件最大 10MB",
    "sourceTitle": "来源标题（可选）",
    "sourceTitlePlaceholder": "例如：独立宣言",
    "activityDetails": "活动详情",
    "objectives": "学习目标",
    "objectivesPlaceholder": "简要描述学生将学到什么...",
    "objectivesHelp": "可选。帮助你整理活动。",
    "creating": "创建中...",
    "createActivity": "创建活动",
    "nextGenerateQuestions": "下一步：生成并审阅题目",
    "removeFile": "移除文件",
    "clickToChangeFile": "点击更换文件",
    "analyzingContent": "正在分析内容...",
    "extractingTitle": "正在提取来源标题...",
    "generatingTitle": "正在生成活动标题...",
    "suggestingObjectives": "正在建议学习目标...",
    "readingPdf": "正在读取 PDF...",
    "extractingText": "正在提取文本...",
    "processingPages": "正在处理页面..."
  },
  "teacherCourses": {
    "title": "课程",
    "subtitle": "将教学组织为课程、单元和课时",
    "startNow": "立即开始",
    "newCourse": "新建课程",
    "noCourses": "暂无课程",
    "noCoursesHelp": "创建你的第一个课程，开始将活动组织成结构化的课程体系。",
    "createCourse": "创建课程"
  },
  "teacherCourseNew": {
    "title": "新建课程",
    "subtitle": "创建新课程来组织你的教学",
    "backToCourses": "返回课程",
    "titleField": "标题",
    "description": "描述",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "titlePlaceholder": "例如：英语101 — 2026春季",
    "descriptionPlaceholder": "课程简介...",
    "creating": "创建中...",
    "createCourse": "创建课程"
  },
  "teacherCourseEdit": {
    "title": "编辑课程",
    "backToCourse": "返回课程",
    "titleField": "标题",
    "description": "描述",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "saveChanges": "保存更改",
    "deleteCourse": "删除课程",
    "deleteWarning": "永久删除此课程及其所有单元和课时。",
    "deleteConfirm": "确定删除此课程吗？所有单元和课时都将被删除，此操作不可撤销。"
  },
  "teacherCourseShow": {
    "editCourse": "编辑课程",
    "backToCourses": "返回课程",
    "studentsEnrolled": "已注册学生",
    "books": "书籍",
    "chapters": "章",
    "passages": "段落",
    "assignedToUnit": "已分配到单元",
    "addUnit": "添加单元",
    "noUnits": "暂无单元",
    "noUnitsHelp": "添加第一个单元，开始在此课程中组织课时。",
    "addAUnit": "添加单元",
    "noUnitsDrag": "暂无单元。拖拽上方的书籍或点击\"添加单元\"开始。",
    "planChapters": "规划章节",
    "assignChapters": "将章节分配到课时",
    "noLessons": "此单元暂无课时。",
    "addLesson": "添加课时",
    "addLessonShort": "添加课时",
    "searchStudents": "按姓名或邮箱搜索学生...",
    "noStudentsFound": "未找到学生",
    "noStudentsEnrolled": "暂无注册学生。在上方搜索以添加学生。",
    "removeStudent": "移除学生",
    "addAnotherBook": "添加另一本书",
    "dropFileHere": "将文件拖放到此处以添加阅读材料",
    "dragBookToCreate": "将书籍拖到下方放置区以创建单元",
    "creatingUnit": "创建单元中...",
    "dropBookHere": "将书籍拖放到此处以创建单元"
  },
  "teacherCourseVocab": {
    "assignedLists": "已分配的词汇表",
    "assignList": "分配词汇表",
    "assignListPlus": "+ 分配词汇表",
    "searchSystemLists": "搜索系统词汇表...",
    "noMatchingLists": "没有匹配的词汇表",
    "noSystemLists": "尚未分配系统词汇表。分配 AWL、频率或备考词汇表以推送给注册学生。",
    "unassignList": "取消分配词汇表",
    "courseWordList": "课程词汇表",
    "noWordsYet": "暂无词汇。从下方的章节建议中添加词汇。",
    "pos": "词性",
    "frequency": "频率",
    "context": "上下文",
    "removeWord": "移除词汇",
    "vocabFromReadings": "阅读材料中的词汇",
    "vocabFromReadingsDesc": "从本课程附带书籍中预先计算的词汇建议。",
    "loadingChapters": "正在加载章节建议...",
    "noBooksAttached": "本课程尚未附带书籍。添加书籍后即可查看词汇建议。",
    "noChapterSuggestions": "暂无章节词汇建议。仍可使用上方搜索整本书。",
    "suggestions": "建议",
    "alreadyAdded": "已添加",
    "wordsSelected": "词已选择",
    "addWords": "添加词汇",
    "addingWords": "添加词汇中...",
    "word": "词汇",
    "findContext": "在书中查找语境",
    "findContextDesc": "搜索整本书，比较不同章节中的例句，然后选择学生将看到的语境。",
    "chooseBook": "选择书籍",
    "searchBookPlaceholder": "搜索词汇…",
    "searchFailed": "无法完成书籍搜索，请重试。",
    "noBookMatches": "本书中未找到该词或其相关形式。",
    "occurrencesFound": "本书中共 {{count}} 处",
    "relatedForm": "相关形式：{{word}}",
    "useThisContext": "使用此语境",
    "contextAdded": "已使用所选语境添加 {{word}}。",
    "wordWasAlreadyAdded": "{{word}} 已在课程词汇表中；已保留原有语境。",
    "addFailed": "无法添加该词，请重试。",
    "addingProgress": "正在添加第 {{current}}/{{total}} 个词…",
    "addedCount": "已成功添加 {{count}} 个词。",
    "switchForm": "切换词形",
    "noRelatedForms": "没有相关词形"
  },
  "teacherLessons": {
    "editLesson": "编辑课时",
    "newLesson": "新建课时",
    "backToLesson": "返回课时",
    "backTo": "返回",
    "titleField": "标题",
    "description": "描述",
    "titlePlaceholder": "例如：第1课：说服术入门",
    "descriptionPlaceholder": "学生在本课时将做什么...",
    "lessonType": "课时类型",
    "typeReading": "阅读",
    "typeWriting": "写作",
    "typeVocabulary": "词汇",
    "typeGrammar": "语法",
    "typeMixed": "综合",
    "scheduledDateTime": "安排日期和时间",
    "durationMinutes": "时长（分钟）",
    "endsAt": "结束于",
    "location": "地点",
    "locationPlaceholder": "教室号、楼栋或 Zoom 链接",
    "creating": "创建中...",
    "createLesson": "创建课时",
    "saveChanges": "保存更改",
    "deleteLesson": "删除课时",
    "deleteWarning": "永久删除此课时。",
    "deleteConfirm": "确定删除此课时吗？此操作不可撤销。",
    "assignedActivities": "已分配的活动"
  },
  "teacherAssessments": {
    "title": "测评",
    "noAssessments": "暂无测评。运行",
    "seedCommand": "rails vst:generate",
    "seedSuffix": "以生成词汇量测试。",
    "itemsInBank": "题库题目",
    "completedAdministrations": "已完成的测评次数",
    "tryIt": "试一试",
    "tryItPreview": "试一试（预览）",
    "totalItems": "题目总数",
    "completions": "完成次数",
    "itemBankByBand": "按等级划分的题库",
    "band": "等级",
    "items": "题目",
    "studentResults": "学生成绩",
    "noStudentResults": "暂无学生完成此测评。",
    "vocabSize": "词汇量",
    "gradeLevel": "年级水平",
    "duration": "时长",
    "date": "日期"
  },
  "teacherAssessmentResults": {
    "results": "结果",
    "previewNote": "预览模式——这些结果未被保存。",
    "yourResults": "你的结果",
    "estimatedWordFamilies": "估计词族数",
    "readingLevel": "阅读水平：",
    "completedIn": "完成时间",
    "bandBreakdown": "等级明细",
    "score": "得分",
    "accuracy": "准确率",
    "total": "总计",
    "questionReview": "题目回顾",
    "backToAssessment": "返回测评",
    "allAssessments": "所有测评"
  },
  "teacherCalendar": {
    "title": "日历",
    "subscribe": "订阅",
    "today": "今天",
    "month": "月",
    "week": "周",
    "openLesson": "打开课时",
    "previousMonth": "上个月",
    "nextMonth": "下个月",
    "previousWeek": "上周",
    "nextWeek": "下周",
    "subscribeTitle": "订阅日历",
    "syncDescription": "将您的 StudyFit 日程同步到 Apple 日历、Google 日历、Outlook 或任何支持 iCal 订阅的应用。",
    "hideInstructions": "隐藏说明",
    "howToSubscribe": "如何订阅",
    "tokenWarning": "此链接包含私密令牌，请勿公开分享。如链接泄露，请点击\"重新生成链接\"创建新链接。",
    "generateHelp": "生成日历订阅链接即可开始。",
    "howToSubscribeTitle": "如何订阅",
    "appleCal": "Apple 日历（macOS / iOS）",
    "appleStep1": "打开日历应用",
    "appleStep2": "前往\"文件\"→\"新建日历订阅\"",
    "appleStep3": "粘贴订阅链接并点击\"订阅\"",
    "appleStep4": "选择刷新频率并点击\"确定\"",
    "googleCal": "Google 日历",
    "googleStep1": "在浏览器中打开 Google 日历",
    "googleStep2": "点击\"其他日历\"旁的 +",
    "googleStep3": "选择\"通过网址添加\"",
    "googleStep4": "粘贴订阅链接并点击\"添加日历\"",
    "outlookCal": "Microsoft Outlook",
    "outlookStep1": "打开 Outlook 日历",
    "outlookStep2": "点击\"添加日历\"→\"从网络订阅\"",
    "outlookStep3": "粘贴订阅链接并命名",
    "outlookStep4": "点击\"导入\""
  },
  "teacherLibrary": {
    "title": "资源库",
    "subtitle": "上传书籍、PDF、演示文稿或保存链接",
    "uploadFile": "上传文件",
    "saveLink": "保存链接",
    "searchPlaceholder": "按标题或作者搜索...",
    "unsupportedFile": "请选择 EPUB、PDF 或 PPTX 文件",
    "processingItems": "正在分析的项目",
    "readyItems": "可搜索的项目",
    "failedItems": "处理失败的项目",
    "dropFile": "将文件拖放到此处以添加阅读材料",
    "addAnotherBook": "添加另一本书",
    "dragToCreate": "将书籍拖到下方放置区以创建单元",
    "dropHere": "将 EPUB、PDF 或 PPTX 拖放到此处或点击浏览",
    "addFirstItem": "添加你的第一个项目",
    "addFirstItemHelp": "将 EPUB、PDF 或 PPTX 文件拖放到此处。AI 语义搜索帮助你即时找到相关段落。",
    "processingUpload": "处理上传中...",
    "chooseFile": "选择文件",
    "backToDictionary": "返回词典",
    "usedIn": "使用于：",
    "searchPassages": "搜索段落...",
    "tableOfContents": "目录",
    "previousPage": "上一页",
    "nextPage": "下一页",
    "page": "页",
    "searchForPassages": "搜索段落或选择一个章节",
    "searchToStart": "搜索段落以开始",
    "partOf": "属于{{series}}"
  },
  "teacherLibraryEdit": {
    "editItem": "编辑项目",
    "titleField": "标题",
    "author": "作者",
    "authorPlaceholder": "作者姓名（可选）",
    "category": "分类",
    "noCategory": "无分类",
    "url": "网址",
    "type": "类型：",
    "language": "语言：",
    "saveChanges": "保存更改",
    "viewContent": "查看内容",
    "toReference": "以便编辑时参考",
    "cantDelete": "此项目无法删除，因为它正被用于",
    "activeCourse": "一个进行中的课程",
    "activeCourses": "个进行中的课程",
    "deleteItem": "删除项目"
  },
  "teacherProfile": {
    "title": "个人资料",
    "subtitle": "您的账户信息"
  },
  "teacherSessions": {
    "addStimulusFirst": "请先添加素材并审批至少一道题目",
    "couldNotCreate": "无法创建课堂",
    "sessionActive": "课堂已开始",
    "sessionCompleted": "课堂已结束"
  },
  "dictionary": {
    "title": "词典",
    "vocabDictionary": "词汇词典",
    "explore": "探索",
    "wordsWithDefs": "个词汇，包含释义、词素和词族",
    "words": "词汇",
    "definitions": "释义",
    "morphemes": "词素",
    "wordFamilies": "词族",
    "vocabularyLists": "词汇表",
    "searchResults": "搜索结果",
    "found": "个结果",
    "noWordsFound": "未找到匹配的词汇",
    "tryDifferent": "尝试不同的拼写或浏览下方推荐词汇",
    "rareWords": "稀有词汇",
    "rareWordsDesc": "值得了解的不常见词汇",
    "browseByCategory": "按分类浏览",
    "byFrequencyBand": "按频率分组",
    "frequencyBandDesc": "按英语中出现频率分组的词汇",
    "byBeckTier": "按 Beck 层级",
    "beckTierDesc": "按教学重要性分类的词汇",
    "backToDictionary": "返回词典",
    "morphemeBreakdown": "词素分析",
    "wordFamily": "词族",
    "relatedWords": "相关词汇",
    "synonyms": "同义词",
    "antonyms": "反义词",
    "browseMoreWords": "浏览更多词汇",
    "viewVocabLists": "查看词汇表",
    "dictionaryDataFrom": "词典数据来自",
    "openEnglishWordNet": "Open English WordNet",
    "ccBy4": "（CC BY 4.0）和",
    "wiktionary": "Wiktionary",
    "ccBySa3": "（CC BY-SA 3.0）",
    "addToClassList": "添加到课程词汇表",
    "addedTo": "已添加到",
    "noDefinitions": "暂无释义。",
    "matchesYourContext": "你句子中的含义",
    "searchPlaceholder": "搜索词汇...",
    "searching": "搜索中...",
    "wordsWith": "包含以下词素的词汇",
    "headword": "词头：",
    "family": "词族：{{headword}}",
    "exampleSentences": "例句",
    "aiGenerated": "AI 生成"
  },
  "morphemes": {
    "prefix": "前缀",
    "root": "词根",
    "suffix": "后缀",
    "bound": "粘着",
    "infix": "中缀"
  },
  "frequency": {
    "top1k": "前1000",
    "top2k": "前2000",
    "top3k": "前3000",
    "top5k": "前5000",
    "top10k": "前10000",
    "rare": "稀有",
    "scoreLabel": "频率分数：{{score}}（Zipf 量表）"
  },
  "pos": {
    "noun": "名词",
    "verb": "动词",
    "adj": "形容词",
    "adv": "副词",
    "prep": "介词",
    "conj": "连词",
    "pron": "代词",
    "det": "限定词",
    "interj": "感叹词"
  },
  "tier": {
    "tier1": "第一层",
    "tier2": "第二层",
    "tier3": "第三层",
    "tier1Desc": "通过日常会话习得的基础词汇",
    "tier1Examples": "dog, run, happy, big",
    "tier1Teaching": "很少需要专门教授",
    "tier2Desc": "跨学科的高频学术词汇",
    "tier2Examples": "analyze, contrast, evidence, reluctant",
    "tier2Teaching": "值得专门教授",
    "tier3Desc": "低频的专业领域术语",
    "tier3Examples": "isotope, photosynthesis, accipitriformes",
    "tier3Teaching": "仅在特定内容需要时教授",
    "beckTitle": "Beck 层级（Isabel Beck 的词汇框架）",
    "sweetSpot": "最佳切入点",
    "tierLabel": "第{{tier}}层",
    "examplesLabel": "例如：{{examples}}"
  },
  "vocabLists": {
    "title": "词汇表",
    "subtitle": "精选的学习词汇合集",
    "browseDictionary": "浏览词典",
    "noLists": "暂无可用词汇表。",
    "backToLists": "返回词汇表",
    "source": "来源：",
    "viewAllLists": "查看所有词汇表",
    "emptyList": "此词汇表为空。"
  },
  "questions": {
    "bank": "题库",
    "questionsIn": "题目，位于",
    "import": "导入",
    "createQuestion": "创建题目",
    "searchPlaceholder": "搜索题目...",
    "mcq": "选择题",
    "shortAnswer": "简答题",
    "essay": "论述题",
    "longResponse": "长篇回答",
    "fillBlank": "填空题",
    "tableSort": "表格排序",
    "ai": "AI",
    "manual": "手动",
    "imported": "导入",
    "testfit": "TestFit",
    "includeCourse": "包含课程",
    "noQuestions": "此课时暂无题目",
    "noQuestionsMatch": "没有匹配筛选条件的题目",
    "importQuestions": "导入题目",
    "stimulus": "素材",
    "noStimulus": "无素材",
    "answer": "答案：",
    "questionOf": "第{{current}}题，共{{total}}题",
    "questionType": "题目类型",
    "switchTypeWarning": "切换类型将丢弃选择题选项。是否继续？",
    "prompt": "题干",
    "promptPlaceholder": "在此输入你的题目...",
    "options": "选项",
    "correctAnswer": "正确答案",
    "expectedAnswer": "预期答案（可选）",
    "linkToStimulus": "关联素材（可选）",
    "advanced": "高级",
    "bloomsLevel": "布鲁姆层级",
    "remember": "记忆",
    "understand": "理解",
    "apply": "应用",
    "analyze": "分析",
    "evaluate": "评价",
    "createBloom": "创造",
    "explanation": "解析",
    "explanationPlaceholder": "为什么这是正确答案？",
    "modelAnswer": "范例答案",
    "modelAnswerPlaceholder": "优秀学生回答示例",
    "rubric": "评分标准",
    "rubricPlaceholder": "评分标准",
    "correctOption": "正确答案",
    "markCorrect": "标记为正确",
    "addOption": "添加选项",
    "dropFile": "将 .docx 或 .pdf 拖放到此处，或点击浏览",
    "pasteQuestions": "在此粘贴你的题目...",
    "lines": "行",
    "process": "处理 →"
  },
  "questionImport": {
    "reviewTitle": "审阅导入的题目",
    "questionsFound": "题目已找到",
    "fromPastedText": "来自粘贴的文本",
    "noModelAnswers": "未找到范例答案",
    "questionsMissingAnswers": "题目缺少答案",
    "generateModelAnswers": "从活动的阅读材料生成范例答案。",
    "generateButton": "生成范例答案",
    "extractingText": "正在提取文本...",
    "analyzingQuestions": "正在分析题目...",
    "usuallyFewSeconds": "通常需要几秒钟",
    "importFailed": "导入失败",
    "goBack": "返回",
    "selectedQuestion": "已选题目",
    "readingSource": "正在阅读源材料...",
    "matchingQuestions": "正在匹配题目与段落...",
    "draftingAnswers": "正在起草范例答案...",
    "citingEvidence": "正在引用文本证据...",
    "reviewingQuality": "正在审查答案质量..."
  },
  "atlas": {
    "quizzesTitle": "地图测验",
    "quizzesSubtitle": "选择一个测验来检验你的地理知识。",
    "questionCount_one": "{{count}} 道题",
    "questionCount_other": "{{count}} 道题",
    "startQuiz": "开始测验",
    "politicalMap": "政治地图",
    "apWorldHistory": "AP 世界历史：现代",
    "savedMaps": "已保存的地图",
    "saveMap": "保存地图",
    "loadingMapData": "正在加载地图数据...",
    "showLegend": "显示图例",
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "resetView": "重置视图",
    "legend": "图例",
    "hide": "隐藏",
    "saveConfig": "保存地图配置",
    "saveConfigHelp": "请为此地图配置输入名称。",
    "nameField": "名称",
    "namePlaceholder": "例如：蒙古扩张地图",
    "region": "地区",
    "noneSelected": "未选择",
    "yearRange": "年份范围",
    "ce": "公元",
    "bce": "公元前",
    "focusYear": "焦点年份",
    "attachToCourse": "关联课程（可选）",
    "noCourse": "无课程",
    "overlays": "叠加层",
    "tradeRoutes": "贸易路线",
    "cities": "城市",
    "battles": "战役",
    "events": "事件",
    "migrations": "迁徙"
  },
  "teacherAtlasMapSets": {
    "title": "地图集合",
    "subtitle": "为特定主题的地图集学习精选 GeoJSON 集合。",
    "newMapSet": "新建地图集合",
    "noMapSets": "暂无地图集合。创建一个，开始整理像“德国统一”这样的主题。",
    "createFirstMapSet": "创建你的第一个地图集合",
    "shared": "共享",
    "viewMapSet": "查看地图集合"
  },
  "feedback": {
    "showThinking": "显示思考过程",
    "hideThinking": "隐藏",
    "answerChoices": "答案选项",
    "correctMark": "正确",
    "incorrectMark": "你的答案",
    "yourAnswer": "（你的答案）",
    "yourCategorization": "你的分类",
    "noItemsPlaced": "未放置任何项目",
    "missing": "缺少：",
    "yourResponse": "你的回答",
    "noResponse": "未回答",
    "modelAnswer": "范例答案",
    "feedbackLabel": "反馈",
    "skillsAssessed": "评估的技能"
  },
  "homework": {
    "title": "作业",
    "viewBank": "查看题库",
    "noItems": "暂无作业项目",
    "addActivity": "添加活动",
    "addFromBank": "从题库添加",
    "chooseActivity": "选择一个活动",
    "noActivities": "暂无可用活动",
    "addToHomework": "添加到作业",
    "untitled": "未命名",
    "fromLesson": "来自 {{title}}",
    "questionsCount": "{{count}} 道题目",
    "stimulusLabel": "素材：{{title}}",
    "instructionsPlaceholder": "教师说明（例如：\"完成第3-5题\"）",
    "editInstructions": "编辑说明",
    "removeFromHomework": "从作业中移除",
    "removeConfirm": "从作业中移除此项目吗？原始内容不会被删除。",
    "answeredCount": "{{answered}}/{{total}} 已作答",
    "submitting": "提交中...",
    "submitHomework": "提交作业",
    "readingPassage": "阅读段落"
  },
  "stimulus": {
    "minRead": "{{minutes}} 分钟阅读",
    "offlineTitle": "想要离线阅读吗？",
    "offlineDescription": "打印此文章以获得更好的专注力。准备好后回到这里继续。",
    "iveReadIt": "我已读完",
    "finishedReading": "读完了吗？",
    "continueToQuestions": "继续答题",
    "contentFrom": "内容来自 {{domain}}",
    "openExternal": "打开外部资源",
    "instructions": "说明：",
    "externalHelp": "点击上方按钮在新标签页中打开资源。花时间阅读和理解内容，然后回到这里继续。",
    "pdfNotAvailable": "PDF 不可用",
    "pageOf": "第 {{current}} 页，共 {{total}} 页",
    "failedToLoadPdf": "PDF 加载失败",
    "tryDownloading": "请尝试下载 PDF",
    "loadingPdf": "正在加载 PDF...",
    "videoContent": "视频内容",
    "videoUnavailable": "视频内容不可用",
    "imageContent": "图片内容",
    "imageUnavailable": "图片不可用",
    "expand": "展开",
    "uploadedHandwritten": "已上传的手写作业",
    "handwrittenPrompt": "有手写笔记？拖放图片或点击上传"
  },
  "ui": {
    "switchToLight": "切换到浅色模式",
    "switchToDark": "切换到深色模式"
  },
  "sessionMap": {
    "unanswered": "未作答",
    "answered": "已作答",
    "currentlyViewing": "正在查看",
    "noStudentsYet": "暂无学生加入。分享加入代码即可开始。",
    "noApprovedQuestions": "此活动暂无已审批的题目。"
  },
  "lessonFlow": {
    "priorHw": "前次作业",
    "hw": "作业",
    "read": "阅读",
    "live": "实时",
    "essay": "作文",
    "assess": "测评",
    "vocab": "词汇",
    "pres": "演示",
    "assessment": "测评"
  },
  "wordHighlight": {
    "addToMyList": "+ 添加到我的词汇表",
    "addToList": "+ 添加到 {{name}}",
    "addToCourseList": "+ 添加到课程词汇表...",
    "noCourseListsYet": "暂无课程词汇表"
  },
  "tableCompletion": {
    "wordBank": "词库",
    "allItemsPlaced": "所有项目已放置",
    "dropItemsHere": "将项目拖放到此处",
    "itemsPlaced": "{{placed}}/{{total}} 项已放置",
    "removeItem": "移除 {{item}}"
  },
  "essayResponse": {
    "placeholder": "在此撰写你的文章...",
    "bold": "粗体",
    "italic": "斜体",
    "heading": "标题",
    "quote": "引用",
    "markdownSupported": "支持 Markdown",
    "wordsExpected": "论述题 • 预期 {{min}}-{{max}} 词",
    "wordCount": "{{count}} 词"
  },
  "flash": {
    "pleaseLogIn": "请登录以继续",
    "accessDenied": "访问被拒绝",
    "invalidCredentials": "邮箱或密码无效",
    "loggedOut": "您已退出登录",
    "profileUpdated": "个人资料已更新",
    "courseCreated": "课程已创建",
    "courseUpdated": "课程已更新",
    "courseDeleted": "课程已删除",
    "unsupportedFileType": "不支持的文件类型。",
    "fileUploaded": "文件已上传，处理即将完成。",
    "bookRemoved": "书籍已从课程中移除。",
    "studentEnrolled": "学生已注册",
    "studentRemoved": "学生已移除",
    "lessonCreated": "课时已创建",
    "lessonUpdated": "课时已更新",
    "lessonDeleted": "课时已删除",
    "chapterNotAssociated": "该章节与此课时或相邻课时无关联",
    "activityAlreadyExists": "此章节的活动已存在",
    "activityCreatedFromChapter": "已从章节创建活动",
    "activityUpdated": "活动已更新",
    "activityDeleted": "活动已删除",
    "unitCreated": "单元已创建",
    "unitUpdated": "单元已更新",
    "unitDeleted": "单元已删除",
    "noAssociatedBook": "此单元没有关联的书籍",
    "chapterPlanSaved": "章节计划已保存",
    "stimulusAdded": "素材已添加",
    "noStimulusFound": "未找到素材",
    "stimulusUpdated": "素材已更新",
    "stimulusRemoved": "素材已移除",
    "addStimulusFirst": "请先添加素材",
    "importStarted": "导入已开始，题目即将准备好以供审阅。",
    "importStartedNotify": "导入已开始，题目准备好后我们会通知您。",
    "questionsImported": "{{count}} 道题目导入成功。",
    "itemUpdated": "项目已更新。",
    "itemDeleted": "项目已删除。",
    "cantDeleteInUse": "此项目无法删除，因为它正被用于进行中的课程。",
    "alreadyInLibrary": "您的资源库中已有\"{{title}}\"。",
    "uploadedProcessing": "{{type}} 已上传，处理即将完成。",
    "linkSaved": "链接已保存，处理即将完成。",
    "lessonAssigned": "课时已分配到 {{title}}",
    "assessmentAlreadyInLesson": "此测评已在本课时中",
    "assessmentAdded": "测评已添加到课时",
    "assessmentNotFound": "测评未找到或尚未就绪",
    "removedFromLesson": "已从课时中移除",
    "noActiveTrial": "没有进行中的试测。",
    "userCreated": "用户 {{name}} 创建成功",
    "userUpdated": "用户 {{name}} 更新成功",
    "userEmailExists": "该邮箱已被注册",
    "teacherAccountCreated": "已为 {{email}} 创建教师账号。邮件邀请即将发送。"
  }
}
